var map = {
	"./cs/main2.yml": 79,
	"./da/main2.yml": 80,
	"./de/main2.yml": 81,
	"./el/main2.yml": 82,
	"./en/main2.yml": 83,
	"./eo/main2.yml": 84,
	"./es/main2.yml": 85,
	"./fi/main2.yml": 86,
	"./fr/main2.yml": 87,
	"./gd/main2.yml": 88,
	"./gl/main2.yml": 89,
	"./hr/main2.yml": 90,
	"./id/main2.yml": 91,
	"./it/main2.yml": 92,
	"./nb_NO/main2.yml": 93,
	"./nn/main2.yml": 94,
	"./pl/main2.yml": 95,
	"./ru/main2.yml": 96,
	"./si/main2.yml": 97,
	"./tr/main2.yml": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;